import { useIndicatorStore } from '@mygpt/app/access/indicator/hooks/useIndicatorContext';
import { useEffect } from 'react';

export const CloseIndicator = () => {
  const store = useIndicatorStore();

  useEffect(() => {
    store.close();
  }, [store]);

  return null;
};
